import React from "react";

interface ReportLayoutProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

const ReportLayout = ({ title, description, children }: ReportLayoutProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold tracking-tight">
          {title}
        </h1>
        <p className="text-muted-foreground">{description}</p>
      </div>
      {children}
    </div>
  );
};

export default ReportLayout;
